<template>
  <!-- eslint-disable-next-line vue/no-mutating-props -->
  <el-input v-model.trim="formInline[item.key]"
    :placeholder="getValue(item, 'placeholder', placeholder)"
    :type="
      (item &&
        item.options &&
        (item.options.type === 'number' ? 'text' : item.options.type)) ||
      'text'
    "
    :clearable="getValue(item, 'clearable', false)"
    :disabled="getValue(item, 'disabled', false)"
    :maxlength="getValue(item, 'maxlength', defaultMaxLenght)"
    v-show="!item.showFn || item.showFn(formInline)"
    @change="(event) => changeSelect(event, item)"
    @input="() => numberMax(item,item &&item.options && item.options.max || '')"
  >
    <i v-if="item && item.options && item.options.iconPercent" slot="suffix"
      >%</i
    >
    <template v-if="getValue(item, 'prepend', '')" slot="prepend">{{getValue(item, 'prepend', '')}}</template>
    <template v-if="getValue(item, 'append', '')" slot="append">{{getValue(item, 'append', '')}}</template>
  </el-input>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    formInline: {
      type: Object,
      default: () => ({}),
    },
    // eslint-disable-next-line vue/no-unused-properties
    change: {
      type: Function,
      default: () => {},
    },
  },
  inject: {
    defaultMaxLenght: 'defaultMaxLenght',
    colon: 'colon',
    customTypeList: 'customTypeList',
    getValue: 'getValue',
    placeholder: 'placeholder',
    selectPlaceholder: 'selectPlaceholder',
    customInputHandle: 'customInputHandle',
    telBlur: 'telBlur',
    numberMax: 'numberMax',
    changeSelect: 'changeSelect',
  },
  data() {
    return {
    }
  },
  watch: {
  },
}
</script>
